import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"

type ScenariosTableProps = {
  scenarios: string[]
  minWidth?: number
}

const ScenariosTable = ({ scenarios, minWidth }: ScenariosTableProps) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: minWidth || 550 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Scenario name</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {scenarios.map((scenario) => (
            <TableRow key={scenario} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell component="th" scope="row">
                {scenario}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ScenariosTable
